var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewBox",style:({
    background: ("url(" + _vm.bj + ")"),
    backgroundSize: '100% 100%'
  })},[_c('div',{staticClass:"viewBox-box"},[(_vm.type == 'view')?[_vm._t("default")]:_vm._e(),(_vm.type == 'text')?[_c('img',{staticClass:"text-title",attrs:{"src":_vm.titlimg,"alt":""}}),_c('div',{staticClass:"text-boxdiv",style:({ height: _vm.textTopHeader + 'rem' })}),_c('div',{staticClass:"text-box",style:({
          width: 690 - _vm.textPadding * 2 + 'rem',
          padding: ("0 " + _vm.textPadding + "rem"),
          overflow: _vm.textoverflow
        })},[_vm._t("default")],2)]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }